<template>
  <v-app>    
    <div class="backgroundColor full-height pb-14">
      <router-view />
      <v-snackbar v-show="toast.show" v-model="toast.show" :color="toast.color">{{ toast.message }}</v-snackbar>
    </div>
    <v-footer v-if="footerStatus" app fixed class="backgroundColor footer">
      <v-row justify="start" class="ml-4">
        <img src="./assets/powered_by.svg" :height="25" />
      </v-row>
      <v-row justify="end">
        <v-btn
          class="text-capitalize"
          text
          color="accent"
          href="mailto:customersupport@beezsocialerp.com"
          target="_blank"
          >Customer Support</v-btn
        >
      </v-row>
    </v-footer>
    
  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
export default {
  created(){

  },
  computed: {
    ...mapFields("toast", ["toast"]),
    footerStatus: function() {
      if (this.$route.name == "dashboard") {
        return false;
      } else {
        return true;
      }
    }
  }

};
</script>
